import React from 'react';
import './CaseStudies.css';

const CaseStudies = () => {
    const caseStudies = [
        {
            company: "某大型制造企业",
            industry: "制造业",
            title: "ERP系统升级改造",
            description: "通过定制化ERP系统，实现生产流程数字化管理，生产效率提升40%，库存成本降低25%",
            results: ["效率提升40%", "成本降低25%", "数据准确率99.9%"],
            image: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            fallbackImage: "https://via.placeholder.com/800x600/2563eb/ffffff?text=ERP+系统升级",
            icon: "🏭"
        },
        {
            company: "某连锁餐饮品牌",
            industry: "餐饮零售",
            title: "全渠道小程序商城",
            description: "开发微信小程序商城，整合线上线下会员系统，3个月内GMV突破500万，复购率提升35%",
            results: ["GMV 500万+", "复购率+35%", "会员数10万+"],
            image: "https://images.unsplash.com/photo-1556740714-a8395b3bf30f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            fallbackImage: "https://via.placeholder.com/800x600/7c3aed/ffffff?text=小程序商城",
            icon: "🍔"
        },
        {
            company: "某金融科技公司",
            industry: "金融科技",
            title: "智能风控AI系统",
            description: "基于机器学习的智能风控系统，实现实时反欺诈检测，准确率98.5%，每年减少损失超2000万",
            results: ["准确率98.5%", "减少损失2000万", "实时检测"],
            image: "https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            fallbackImage: "https://via.placeholder.com/800x600/db2777/ffffff?text=智能风控",
            icon: "💳"
        },
        {
            company: "某教育机构",
            industry: "在线教育",
            title: "在线学习APP",
            description: "打造互动式在线学习平台，支持直播、录播、作业批改，用户数突破50万，日活5万+",
            results: ["用户50万+", "日活5万+", "课程1000+"],
            image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            fallbackImage: "https://via.placeholder.com/800x600/ea580c/ffffff?text=在线教育",
            icon: "📚"
        }
    ];

    return <section id="case-studies" className="case-studies-section">
        <div className="section-header">
            <h2>成功案例</h2>
            <p>助力企业实现数字化转型的实践成果</p>
        </div>
        <div className="case-studies-grid">
            {caseStudies.map((caseStudy, index) => (
                <div key={index} className="case-study-card">
                    <div className="case-study-image-wrapper">
                        <img
                            src={caseStudy.image}
                            alt={caseStudy.title}
                            className="case-study-image"
                            loading="lazy"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = caseStudy.fallbackImage;
                            }}
                        />
                        <div className="case-study-icon">{caseStudy.icon}</div>
                    </div>
                    <div className="case-study-content">
                        <div className="case-study-header">
                            <h3>{caseStudy.title}</h3>
                            <span className="case-study-industry">{caseStudy.industry}</span>
                        </div>
                        <p className="case-study-description">{caseStudy.description}</p>
                        <div className="case-study-results">
                            {caseStudy.results.map((result, idx) => (
                                <span key={idx} className="result-tag">{result}</span>
                            ))}
                        </div>
                        <div className="case-study-footer">
                            <span className="case-study-company">{caseStudy.company}</span>
                            <button className="case-study-btn">查看详情 →</button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </section>
}

export default CaseStudies;